import { render, staticRenderFns } from "./PostitBoard.vue?vue&type=template&id=309ae8c6&scoped=true"
import script from "./PostitBoard.vue?vue&type=script&lang=js"
export * from "./PostitBoard.vue?vue&type=script&lang=js"
import style0 from "./PostitBoard.vue?vue&type=style&index=0&id=309ae8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ae8c6",
  null
  
)

export default component.exports